import React, { PureComponent } from 'react';
import './style.scss';
import Table from '../../../../../components/table';
import { connect } from 'react-redux';
import { ACTIONS, getTeam1, convertBatterPitcherUse, convertListBatter } from './../../../../../actions/team-1';
import Loading from '../../../../../components/loading';
import { Link} from "react-router-dom";

class Appointment extends PureComponent {

	constructor(props) {
        super(props);
        this.state = {
			listUseTeamReport : [],
			showLoading: false,
			listTop3Used: []
        }
        this.onRedirect = this.onRedirect.bind(this);
    }

    componentDidMount() {
        this.setState({showLoading: true})
        const id = this.props.id;
        this.props.getTeam1(id);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps) {
            if (nextProps.status === ACTIONS.GET_INFO_TEAM_1_SUCCESS) {
                this.setState({
					showLoading: false,
					listUseTeamReport : nextProps.response.top3_pitchers && convertBatterPitcherUse(nextProps.response.top3_pitchers[0].players, nextProps.id),
					listTop3Used: convertListBatter(nextProps.response.top3_used, nextProps.id)
                })
            }
        }
	}

	onRedirect(value) {
		this.props.history.push(`/player/${value.id}`);
	}

	render() {
		return (
			<div className="appoint">
				<h3 className="appoint-title">起用TOP3</h3>
				<div className="grid">
				{
                        this.state.listTop3Used && this.state.listTop3Used.map((value, index) => {
                            return (
                                <div className="appoint-block" key={index}>
                                    <Table
                                        header={value.headerTable}
                                        showCheckbox={false}
                                        showSearch={false}
                                        itemOfPage={value.items}
                                        isShowOptionTable={false}
                                        titleTable={value.title}
                                        showPagination={false}
										onRowClick={this.onRedirect}
                                    />
                                </div>
                            )
                        })
                    }
				</div>

				<Loading show={this.state.showLoading} />
			</div>
		);
	}
}

const mapStateToProps = ({ teams }) => {
	return {
		header: teams.headerAppointment,
		titleSlapTable: teams.titleSlapTable,
		mockDataSlapTable: teams.mockDataSlapTable,
		titleSprintTable: teams.titleSprintTable,
		mockDataSprintTable: teams.mockDataSprintTable,
		titleRescueTable: teams.titleRescueTable,
		mockDataRescueTable: teams.mockDataRescueTable,
		response: teams.response,
        status: teams.status
	};
}

const mapDispatchToProps = dispatch => {
	return {
		getTeam1: (id) => {
            dispatch(getTeam1(id))
        }
	};
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure : false })(Appointment);
